<template>
  <div id="destination">
    <div class="destinations-container">
      <div class="row">
        <div class="col-12 d-flex flex-column justify-content-center align-items-center w-100">
          <div class="destination-header text-center">
            <h2 class="merriweather-reg-20">Nos destinations</h2>
            <h2 class="merriweather-reg-28">En vogue</h2>
            <p class="merriweather-light-18">Des <span class="merriweather-light-italic-18">privilèges exclusifs</span> vous attendent dans chaque destination.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tab-wrapper pt-2">
          <div
            v-for="(category, index) in destinationCategories"
            :key="index"
            :class="['category-tab', activeCategory === category ? 'active raleway-bold-p16' : 'raleway-bold-p14']"
            @click="setActiveCategory(category)"
          >
            {{ category }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pt-4">
          <CarddestiPhone :regions="filteredRegions" data-aos="fade-up" data-aos-duration="900"></CarddestiPhone>
        </div>
      </div>
      <div class="w-100 text-nowrap">
        <a class="hortense-btn-primary raleway-bold-p" :href="'/destination'" target="_blank">Découvrir toutes nos destinations</a>
      </div>
    </div>
  </div>
</template>


<script>

  import CarddestiPhone from '../components/cards-phone/CarddestiPhone.vue';
  import AOS from 'aos';

  export default {
    name: 'destination',
    components: { CarddestiPhone },
    props: {
      destinations: Array
    },
    data() {
      return {
        activeCategory: 'FRANCE'
      }
    },
    computed: {
      destinationCategories() {
        return ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'];
      },
      filteredRegions() {
        return this.destinations?.filter(desti => desti.name.toLowerCase() === this.activeCategory.toLowerCase())?.[0]?.regions || [];
      }
    },
    methods: {
      setActiveCategory(category) {
        this.activeCategory = category;
      }
    },
    mounted(){
      AOS.init();
    }
  }
</script>


<style scoped lang="scss">
#destination{
  padding-top: 80px;

  .tab-wrapper {
    margin-bottom: 3rem;
    white-space: nowrap;
    padding: 0 13px 0 13px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: 0px;
    overflow-x: auto;

    .category-tab {
      cursor: pointer;
      font-weight: 500;
      text-transform: uppercase;
      color: #333;
  
      &.active {
        border-bottom: 2px solid #000;
      }
    }
  }
  
  .destinations-container {
    padding-right: 20px;
    padding-left: 20px;
    gap: 21px;
  }

  .slither-slider-controls{
    display: flex;
    justify-content: space-around;
    padding-top: 2rem;
  }

  .slither-slider-slide {
    position: relative;
    height: auto;
    display: grid;
    grid-template-columns: repeat(4, minmax(0px, 1fr)) !important;
    gap: 0;
  }
}

.col-grid-desti{
  img{
    width: 170px !important;
    height: 160px !important;
    object-fit: cover;
  }
}
</style>
